import type {
  UpdateContractsMutation,
  UpdateContractsMutationVariables
} from './__generated__/UpdateContractsMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import { contractFragment } from '../fragments/ContractFragment'

const mutation: TypedDocumentNode<
  UpdateContractsMutation,
  UpdateContractsMutationVariables
> = gql`
  ${contractFragment}

  mutation UpdateContractsMutation($input: UpdateContractsInput!) {
    updateContracts(input: $input) {
      contracts {
        ...ContractFragment
      }
    }
  }
`

export function updateContractsMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      UpdateContractsMutation,
      UpdateContractsMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
